/*** IMPORTS FROM imports-loader ***/
var define = false;

import Flickity from 'flickity';

export function supportNavSlider() {
  // alert('firing');
  var slider = document.querySelector('.supportNav__wrap');
  var flkty = new Flickity(slider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    freeScroll: true,
    pageDots: false,
    adaptiveHeight: false,
    watchCSS: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

  var tapArea, startX;
  tapArea = document.querySelectorAll('.supportNav__wrap');
  startX = 0;
  for (var item of tapArea) {
    item.ontouchstart = function (e) {
      startX = e.touches[0].clientX;
    };
    item.ontouchmove = function (e) {
      if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable) {
        e.preventDefault();
      }
    };
  }
}
